export default "__VITE_ASSET__DU4Z9UfC__"